import { useEffect, useRef } from 'react';
import { cn } from '../../utils/cn';
import type { DeploymentLogLine } from '../../types';

const streamClass: Record<DeploymentLogLine['stream'], string> = {
  stdout: 'text-slate-300',
  stderr: 'text-rose-400',
  pulse: 'text-pulse-400 italic',
};

export function DeploymentLogView({ log, maxHeight = 320 }: { log: DeploymentLogLine[]; maxHeight?: number }) {
  const bottomRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ block: 'end' });
  }, [log.length]);

  if (log.length === 0) {
    return <p className="rounded-lg bg-slate-900 px-3 py-4 text-center text-xs text-slate-500">No output yet.</p>;
  }

  return (
    <div
      className="overflow-y-auto rounded-lg bg-slate-900 px-3 py-2.5 font-mono text-[12px] leading-relaxed scrollbar-thin"
      style={{ maxHeight }}
    >
      {log.map((line, i) => (
        <p key={i} className={cn('whitespace-pre-wrap break-all', streamClass[line.stream])}>
          {line.stream === 'pulse' ? '» ' : ''}
          {line.text}
        </p>
      ))}
      <div ref={bottomRef} />
    </div>
  );
}
